import React, { useState } from "react";
import { Col, Form, Row } from "antd";
import Selects from "../../../../biblio/Selects/Selects";
import { useDispatch, useSelector } from "react-redux";
import { getAllNeighborhood } from "../../../../apis/actions/recipient.actions";
import { AppDispatch, RootState } from "../../../../apis/store";
import NationalAddressForm from "./NationalAddressForm";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { UploadOutlined } from "@ant-design/icons";
import { convertFileToBase64 } from "../../../../components/utils/utils";

interface HousingProps {
  governorates: any;
  form: any;
}

const HousingForm = ({ governorates, form }: HousingProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedGovernorate, setSelectedGovernorate] = useState(null);

  const { neighborhoods } = useSelector((state: RootState) => state.recipient);

  const onGovernorateChange = async (value: any) => {
    setSelectedGovernorate(value);
    try {
      await dispatch(getAllNeighborhood(value.value));
    } catch (error) {
      console.error("Error fetching neighborhoods:", error);
    }
  };
  const handleFileChange = async (fileList: any[]) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };

        form.setFieldsValue({
          national_address_attachment_ids: [imageData],
        });
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };
  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>مقر السكن</span>
      </div>
      <Row gutter={16}>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="governorate_id"
            label="المحافظة"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={governorates?.data}
              onChange={onGovernorateChange}
            />
          </Form.Item>
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="neighborhood_id"
            label="الحي"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects
              options={neighborhoods?.data?.result}
              disabled={!selectedGovernorate}
            />
          </Form.Item>
        </Col>
        <NationalAddressForm />
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name="national_address_attachment_ids"
            label="صورة العنوان الوطني"
            rules={[
              {
                required: true,
                message: "الرجاء تعبئة الحقل",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <UploadInput
              accept="*"
              text="المرفقات"
              icon={<UploadOutlined />}
              multiple={false}
              maxCount={1}
              onChange={handleFileChange}
            />{" "}
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default HousingForm;
